export default __webpack_public_path__ + "static/media/3-2_questioncircle.84dfba83.svg";